import React from "react";
import { CardContainer } from "../../../components/Card";
import { BarChart, LineChart } from "../../../components/Charts";

export default function FacebookTab({ data }) {
    return (
        <CardContainer>
            <LineChart
                data={data}
                series={[
                    {
                        name: "Facebook",
                        key: "ttt_facebook",
                    },
                ]}
                xKey="week"
                title="TTT Facebook Followers"
            />
            <BarChart
                data={data?.map((d) => ({
                    ...d,
                    ttt_facebook_change: d.ttt_facebook_change * 100,
                }))}
                series={[
                    {
                        name: "Facebook Followers",
                        key: "ttt_facebook_change",
                    },
                ]}
                xKey="week"
                title="TTT Facebook Followers % Change"
                yFormatter={(v) => `${v / 100}`}
            />
        </CardContainer>
    );
}
